import React, { Component } from 'react';

class Accessories extends Component {

    constructor(props) {
        super(props);

        this.bon=this.props.bon;
        this.bp = this.bon.serviceCall.businessPartner;
        this.changes = this.props.changes;

        this.accessories = Accessories.GetAccessories(this.bp, this.changes);

        this.state = {
            enableSave: this.props.enableSave,
            accessories: this.accessories,
            confirmedNoPaceMaker: this.changes.state.confirmedNoPaceMaker,
            confirmedNoAccessories: this.changes.state.confirmedNoAccessories
        };


    }

    static GetAccessories(bp, changes) {
        // initialize an array with all accessories
        var accessories=Accessories.getList();
        
        // set the initial number of items
        accessories.map((item, index) => {
            // get changed value (when specified)
            var value = changes.state.accessories[item.propertyName];

            // if there was no change made, get the current number of rented items (this is the number minus the returned number of items)
            if (value === undefined ) {
                var returned = bp.productCountersReturned[item.propertyName];
                value = bp.productCountersRent[item.propertyName];
                if (returned && returned > 0) value -= returned;
                if (value < 0) value = 0;
            }
            item.value = value;
            return true;
        });
        return accessories;

    }

    static getList() {
        return [
            { name: "Handzenders", propertyName: "handzenders" },
            { name: "Collierzenders", propertyName: "collierzenders" },
            { name: "Rookmelders", propertyName: "rookmelder" },
            { name: "Valmelders", propertyName: "valdetector" },
            { name: "Trekkoorden", propertyName: "trekkoord" },
            { name: "Deurcontacten", propertyName: "deurcontact" },
            { name: "Bewegingsmelders", propertyName: "bewegingsmelder" }
        ];
    }

    changeValueUp(evt) {
        this.changeValue(evt, true);
    }

    changeValueDown(evt) {
        this.changeValue(evt, false);
    }

    changeValue(evt, up) {
        var value = evt.target.value;
        const name = evt.target.name;
        
        const accessories = this.state.accessories;
        var item = accessories.find(p => p.propertyName === name);
        value = item.value;

        if (up) value++; 
        else value--;

        if (value<0) {
            alert("Waarde kan niet lager zijn dan 0");
            return;
        }

        console.log(name, value);
        
        this.handleChangeAccessorySetValue(name, value);
    }

    handleChangeAccessory(evt) {
        const name = evt.target.name;
        var value = evt.target.value;
        this.handleChangeAccessorySetValue(name, value);
    }

    handleChangeAccessorySetValue(name,value) {
        const accessories = this.state.accessories;
        var item = accessories.find(p => p.propertyName === name);

        item.value = value;
        this.setState({ accessories: accessories });

        // add the already returned number of items as well
        if (this.bp.productCountersReturned[name] && this.bp.productCountersReturned[name] > 0) {
            value = parseInt(value) + parseInt(this.bp.productCountersReturned[name]);
        }
        this.props.changes.SetAccessory(name, value);
    }
    
    handleCheckbox(evt) {
        const name = evt.target.name;
        const value = evt.target.checked;
        this.setState({ [name]: value });
        this.props.changes.state[name] = value;  // save to the parent object
    }

    render() {
        var bp = this.bp;
        
        var originalCollier=this.bp.productCountersRent.collierzenders;
        var requestedCollier=this.state.accessories.find(p => p.propertyName === "collierzenders").value;

        return <div>
            {this.accessories.map((item, index) => {
                var orgValue = bp.productCountersRent[item.propertyName];
                var returned = bp.productCountersReturned[item.propertyName];
                var changedValue = item.value - orgValue;
                if (returned && returned > 0) changedValue += returned;
                if (changedValue === 0) changedValue = "";
                else if (changedValue > 0) changedValue = "+" + changedValue;

                return <React.Fragment key={item.name}>
                    <div className="row">
                        <div className="col mt-2 col-lg-4 col-md-3">{item.name}</div>
                        <div className="col-md">
                            {!this.state.enableSave &&
                                <span>{item.value}</span>
                            }
                            {this.state.enableSave &&
                                <div className="row">
                                    <div className="col-md-3">
                                <input type="number" inputMode="numeric" pattern="[0-9]*" name={item.propertyName} 
                                    className="form-control number mb-2" max="10" min="0" value={item.value} onChange={this.handleChangeAccessory.bind(this)}></input>
                                    </div>
                                    <div className="col">
                                    <button type="button" className="btn btn-sm ps-3 pe-3 btn-secondary" name={item.propertyName} onClick={this.changeValueUp.bind(this)}>+</button>
                                    <button type="button" className="btn ms-2 ps-3 pe-3 btn-sm btn-secondary" name={item.propertyName} onClick={this.changeValueDown.bind(this)} >-</button>
                                    </div>
                                </div>
                            }

                        </div>
                        <div className="col-md-3 mt-2">{changedValue}</div>
                    </div>
                </React.Fragment>
            })}
            
            {/* when we add a collierzender, make sure that the question for the pacemaker is answered */}
            {((requestedCollier>0 && requestedCollier > originalCollier ) ||                                // we are adding a collier
                (originalCollier>0 && this.bon.serviceCall.problemType===1 && requestedCollier>0)           // or this is a "plaatsing" and originally we configured at least 1 collier to be  install, and we are still installing a collier
            )
                && this.state.enableSave && 
                <div className={this.state.confirmedNoPaceMaker ? "" : "text-danger"}><input type="checkbox" name="confirmedNoPaceMaker" className="me-2"
                    checked={this.state.confirmedNoPaceMaker}
                    onChange={this.handleCheckbox.bind(this)}></input>Klant heeft bevestigd dat hij geen pacemaker heeft.
                </div>
            }

            {/* check that we don't accidentally make all accessories equal to 0 */}
            {this.accessories.reduce((a,v)=> a=a+parseInt(v.value), 0) === 0 && this.state.enableSave && 
                <div className={this.state.confirmedNoAccessories ? "" : "text-danger"}><input type="checkbox" name="confirmedNoAccessories" className="me-2"
                checked={this.state.confirmedNoAccessories}
                onChange={this.handleCheckbox.bind(this)}></input>Ik bevestig dat alle accessoires op 0 behoren te staan.

                <div class="bg-danger text-white">
                    Voeg bij additionele producten een extra regel toe, wannneer accessoires niet retour komen omdat deze kwijt zijn/ontbreken.
                </div>
            </div>
            }
        </div>
    };

}

export default Accessories;